export default __webpack_public_path__ + "static/media/card-image14.63e5844b.png";